// ** React Imports
/* eslint-disable  */
import { Link } from "react-router-dom";
import { useEffect, Fragment, useState } from "react";

// ** Third Party Components
import InputNumber from "rc-input-number";
import PerfectScrollbar from "react-perfect-scrollbar";
import { ShoppingCart, X, Plus, Minus } from "react-feather";

// ** Reactstrap Imports
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Badge,
  Button,
} from "reactstrap";

// ** Styles
import "@styles/react/libs/input-number/input-number.scss";

const CartDropdown = () => {
  // ** State
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // ** ComponentDidMount
  useEffect(() => {}, []);

  // ** Function to toggle Dropdown
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  // ** Function to call on Dropdown Item Click
  const handleDropdownItemClick = (id) => {
    toggle();
  };

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      tag="li"
      className="dropdown-cart nav-item me-25"
    >
      <DropdownToggle tag="a" className="nav-link position-relative">
        <ShoppingCart className="ficon" />
      </DropdownToggle>
      <DropdownMenu
        end
        tag="ul"
        className="dropdown-menu-media dropdown-cart mt-0"
      >
        <li className="dropdown-menu-header"></li>
      </DropdownMenu>
    </Dropdown>
  );
};

export default CartDropdown;
